import { call, put, all } from "redux-saga/effects";
import { validateAPI } from "../api/ValidateCalls";
import { validateSuccess, validateFailure } from "../actions/validateactions";
import { moveToLoginPage } from "../actions/routeactions";
import { reportError } from "../actions/erroractions";

export function* validateSaga(action) {
  const result = yield call(validateAPI, action);
  try {
    if (result.ok) {
      yield all([put(validateSuccess()), put(moveToLoginPage())]);
    } else {
      yield all([
        put(validateFailure()),
        put(reportError(result.message)),
      ]);
    }
  } catch (ex) {
    yield all([put(validateFailure()), put(reportError(ex))]);
  }
}
